import { Suspense, useEffect, useState } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';
import RegisterPage from 'features/register/pages/register.page';
import ReferralCapturePage from 'features/auth/referral-capture.page';
import { RegisterRouteMiddleware } from './register-route-middleware';
import { SplashScreenLayout } from '../../components/layouts/splash-screen.layout';
import authRoutes from '../../features/auth/auth.route';
import { useUserProfileQuery } from 'app/store';
import { Receipt } from './pages.registry';
import { panelRoutes } from './panel-route';

const token = localStorage.getItem('token');
const collapse = localStorage.getItem('sidebar_collapse');

export default function Router() {
    const navigate = useNavigate();
    const { data: profile } = useUserProfileQuery(undefined, {
        skip: !token,
    });
    const path = window.location.pathname;

    // `accept` is a server-side account fact that only changes through a
    // full reload (login/logout), so it is latched once observed. Without
    // the latch, the cache reset that follows a gateway switch clears the
    // profile cache and flips the panel layout back to the splash.
    const [isAccepted, setIsAccepted] = useState(false);

    useEffect(() => {
        if (profile?.status === 'accept') {
            setIsAccepted(true);
        }
    }, [profile?.status]);

    useEffect(() => {
        !token &&
            !path.includes('receipts') &&
            !path.startsWith('/ref/') &&
            navigate('');
    }, [token]);

    useEffect(() => {
        collapse === null && localStorage.setItem('sidebar_collapse', 'true');
    }, []);

    const element = useRoutes([
        {
            path: 'ref/:token',
            element: <ReferralCapturePage />,
        },
        {
            path: 'receipts/:encoded',
            element: <Receipt />,
        },
        !token
            ? authRoutes
            : {
                  element: <RegisterRouteMiddleware />,
                  children: [
                      {
                          path: 'register/*',
                          element: isAccepted ? (
                              <SplashScreenLayout />
                          ) : (
                              <RegisterPage />
                          ),
                      },
                      panelRoutes(isAccepted),
                      {
                          path: '*',
                          element: <>404</>,
                      },
                  ],
              },
    ]);

    return <Suspense fallback={<SplashScreenLayout />}>{element}</Suspense>;
}
